// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/PendingCommunities/index.css
// module id = 3099
// module chunks = 0